import * as Yup from 'yup';

export const CommentFormSchema = Yup.object().shape({
  comment: Yup.string().required(),
});
